// extracted by mini-css-extract-plugin
module.exports = {"preview":"ProductsRecentlyViewed_preview__7bmKI","condensed":"ProductsRecentlyViewed_condensed__Kpwyw","imageWrap":"ProductsRecentlyViewed_imageWrap__03m2t"};